<template>
  <div class="bodyContainer">
    <div class="inlineB">
      <div class="inlineB"><IconConverter class="txtWhte" :txt="displayIcon" fontSize="40vh" /></div>
      <div class="inlineB signDisplayDetailsContainer">
        <div class="inlineB"><IconConverter :txt="displaySignTxt" fontSize="10vh" class="iconBlkGlow signDisplayName" /></div>
        <div class="inlineB signDisplayName">{{displayName}}</div>
 
        <span >
          <IconConverter class="margniLR5 buttonTxt" :txt="displayElementTxt" fontSize="4vh" />
          <IconConverter class="margniLR5 buttonTxt" :txt="displayQualityTxt" fontSize="4vh" />
          <IconConverter class="margniLR5 buttonTxt" :txt="displayHouseTxt" fontSize="4vh" />
          <IconConverter class="margniLR5 buttonTxt" :txt="displayPlanetTxt" fontSize="4vh" />
          <div style="width:100%;display:block;position:relative;" class="buttonTxt">{{startDate}} {{ startMonth }} {{to}} {{ endDate }} {{ endMonth }}</div>
        </span> 

        <!-- <span v-if="hover">
          <IconConverter class="margniLR5 buttonTxt" :txt="displayElementTxt" fontSize="4vh" />
          <IconConverter class="margniLR5 buttonTxt" :txt="displayQualityTxt" fontSize="4vh" />
          <IconConverter class="margniLR5 buttonTxt" :txt="displayHouseTxt" fontSize="4vh" />
          <IconConverter class="margniLR5 buttonTxt" :txt="displayPlanetTxt" fontSize="4vh" />
          <div style="width:100%;display:block;position:relative;" class="buttonTxt">{{startDate}} {{ startMonth }} to {{ endDate }} {{ endMonth }}</div>
        </span> -->
      </div>
    
    </div>

    <!-- <IconConverter :txt="B" fontSize="40vh" /> -->

    <!-- <ul style="display: flex; background-color:green;">
        Other Mapped URL
      <router-link style="flex-grow: 1; background-color:gray;" v-for="allSigns in zodiacData.signs.slice(0,12)" :key="allSigns.signId" :to="{ path: '/zodiacsigns/' + allSigns.signName }" >
        <li class="zodiacSignContainer"  >
          
            <IconConverter :txt="allSigns.glyphDisplayCharacter" fontSize="5vh" />
           <h2 class="signName">{{ allSigns.signName }}  </h2>
      
         <SignsAllIconsDisplayer 
        :signTxt="allSigns.glyphDisplayCharacter"
        :elementTxt="allSigns.elementDisplayCharacter"
        :qualityTxt="allSigns.qualityDisplayCharacter"
        :houseTxt="allSigns.houseDisplayCharacter"
        :planetTxt="allSigns.planetDisplayCharacter"
        fontSize="12px"
        marginBetween="0.5vw" />
      

      
        </li>
      </router-link>
    </ul> -->

    <div
      style="display: block; width:100%';padding-top:10px;"
    >
      <router-link
        style="flex-grow: 1;"
        v-for="allSigns in zodiacData.signs.slice(0, 12)"
        :key="allSigns.signId"
        :to="{ path: '/zodiacsigns/' + allSigns.signName }"
      >
        <div 
          :style="{ 'backgroundColor': 'rgba(' + allSigns.mainColor +', 0.7)' }" class="zodiacSignContainer" 
          @mouseover="hover = true, 
            displayName = allSigns.signName, 
            displayIcon = allSigns.iconDisplayCharacter,
            displaySignTxt= allSigns.glyphDisplayCharacter,
            displayElementTxt= allSigns.elementDisplayCharacter,
            displayQualityTxt= allSigns.qualityDisplayCharacter,
            displayHouseTxt= allSigns.houseDisplayCharacter,
            displayPlanetTxt= allSigns.planetDisplayCharacter,
            startDate = allSigns.startDate,
            endDate= allSigns.endDate,
            startMonth= allSigns.startMonth,
            endMonth= allSigns.endMonth,
            to = 'to'
            "
          @mouseleave="hover = false">
          <IconConverter :txt="allSigns.glyphDisplayCharacter" fontSize="4vw" />
          <h2 class="signName">{{ allSigns.signName }}</h2>



          <SignsAllIconsDisplayer
            :signTxt="allSigns.glyphDisplayCharacter"
            :elementTxt="allSigns.elementDisplayCharacter"
            :qualityTxt="allSigns.qualityDisplayCharacter"
            :houseTxt="allSigns.houseDisplayCharacter"
            :planetTxt="allSigns.planetDisplayCharacter"
            fontSize="1.5vw"
            marginBetween="0.5vw"
          />
          <div style="width:100%;display:block;position:relative;" class="signTileDates">
          {{ allSigns.startDate }} {{ allSigns.startMonth }} to <br>
          {{ allSigns.endDate }} {{ allSigns.endMonth }}
          </div>

        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
  import { mapState } from "vuex";
  import IconConverter from "@/components/converters/IconConverter.vue";
  import SignsAllIconsDisplayer from "@/components/views/SignsAllIconsDisplayer.vue";

  export default {
    data() {
      return {
        info: [],
        hover: false,
        displayName: 'Select A Zodiac Sign',
        displayIcon: ')',
        displaySignTxt: '',
        displayElementTxt: '',
        displayQualityTxt: '',
        displayHouseTxt: '',
        displayPlanetTxt: '',
        startDate: '',
        endDate: '',
        startMonth: '',
        endMonth: '',
        color: 'red',
        to: '',
      };
    },
    computed: mapState([
      "zodiacData",
      "getZodiacSignProfile",
      "currentSignProfile",
      "activeSignProfile",
    ]),

    // methods: {
    // },
    created() {
      // Fetch Data
      // this.fetchData();
    },
    components: {
      IconConverter,
      SignsAllIconsDisplayer,
    },
  };
</script>

<style scoped>
  .bodyContainer {
    /* background-color: orange; */
    /* margin: 0;
    width: 100%; */
    padding: 10px;

        /* background: url('../assets/img/space-Bg.jpg') no-repeat center center fixed;
      -webkit-background-size: cover;
      -moz-background-size: cover;
      -o-background-size: cover;
      background-size: cover;
      margin: 0;
      width: 100%; */


  }
  .zodiacSignContainer {
    display: inline-block;
    position: relative;
    text-align: center;
    width: 15%;
    /* min-width: 12%; */
    /* max-width: 14%;3 */
    /* height: 300px; */
    /* background-color: pink; */
    margin: 0.1vw;
    padding: 5px;
  background-color: rgba(0, 0, 0, 0);
  transition: all ease 0.5s;

  }
  .zodiacSignContainer:hover {

  background-color: rgba(0, 0, 0, 1);
  }
  .signName, .signDisplayName {
    display: inherit;
    font-size: 3vw;
    width: 100%;
    text-align: center;
    margin-block-start: 0em;
    margin-block-end: 0em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
  }
  .signDisplayName{
    display:inline;
    position:relative;
    font-size: 8vh;
    line-height: 8vh;
    color:white;
    /* width:20%; */
  }
  .signTileDates{
    font-size: 2vw;
    line-height: 2vw;
  }

  .inlineB {
    display: inline-block;
    position: relative;
  }
  .block{
    display: block;
    position:relative;
  }
  .margniLR5{
    margin: 0 5px;
  }
  .signDisplayDetailsContainer{
    margin-left: 10px;
  }



.buttonTxt, a, .signDisplayName{
    color:white;
    text-shadow: -1px 0px 3px rgba(0, 0, 0, 1);
}

.iconBlkGlow{
    text-shadow: 0px 0px 40px rgba(255, 255, 255, 1),0px 0px 20px rgba(0, 0, 0, 1);
    /* text-shadow: -1px 0px 21px rgba(0, 0, 0, 1),0px 0px 7px rgba(0, 0, 0, 1); */
}

.txtBlkShadow{
    text-shadow: 0px 1px 3px rgba(0, 0, 0, 1);
}
.txtWhte{
  color: white;
}
/* body {
      background: url('../assets/img/space-Bg.jpg') no-repeat center center fixed;
      -webkit-background-size: cover;
      -moz-background-size: cover;
      -o-background-size: cover;
      background-size: cover;
      margin: 0;
      height: 100vh;
      width: 100%;
      background-color: black;
} */


  /* ul {
    display: inherit;
    margin: 0 auto;
    text-align: center;
    list-style-type: none;
    margin-block-start: 0;
    margin-block-end: 0;
    padding-inline-start: 0;
  }
  li {
    text-align: center;
    display: inherit;
  } */
  /* li { text-align:center; display:inline-block; padding:0; float: left; } */
  /* img { width:64px; display:block; margin:0 auto }*/
  /* li:nth-child(3) { clear: left; }
li:nth-child(5) { clear: left; }
li:nth-child(7) { clear: left; }
li:nth-child(9) { clear: left; }
li:nth-child(11) { clear: left; }
li:nth-child(13) { clear: left; }  */

  /* ul a{ text-align:center; display:table-cell; padding:0; } */

  /* ul a:nth-child(8) { display:block;  background-color: red;}  */

  /* ul a:nth-child(13) { clear: left; } */
</style>
